__turbopack_context__.v({
  "backButton": "KundaliFormCard-progressive-module__wpCS5a__backButton",
  "finalAction": "KundaliFormCard-progressive-module__wpCS5a__finalAction",
  "nextButton": "KundaliFormCard-progressive-module__wpCS5a__nextButton",
  "progressRail": "KundaliFormCard-progressive-module__wpCS5a__progressRail",
  "progressiveSection": "KundaliFormCard-progressive-module__wpCS5a__progressiveSection",
  "stepNavigation": "KundaliFormCard-progressive-module__wpCS5a__stepNavigation",
});
